const EMAIL_REGEX = /^([a-zA-Z0-9.%+_-]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/

export const isValidEmail = (
  email?: string | null,
  options: { allowEmpty: boolean } = { allowEmpty: false }
) => {
  return email ? EMAIL_REGEX.test(email.trim()) : options.allowEmpty
}
